import axios from "axios";
import getAuthHeaders from "../../utils/get-auth-headers";
import loginApiEndpoint from "./login-api-endpoint";

const {
  headers,
} = getAuthHeaders();

const {
  forgotPasswordUrl,
  changePasswordUrl,
  sendOTPUrl,
  validateOTPUrl,
  markAsUsedUrl,
} = loginApiEndpoint();

const loginApi = () => {
  const forgotPasswordApi = async (data) => {
    const response = await axios.post(forgotPasswordUrl, data, headers);
    return response.data;
  }
  const changePasswordApi = async (data) => {
    const response = await axios.post(changePasswordUrl, data, headers);
    return response.data;
  }
  const sendOTPApi = async (data) => {
    const response = await axios.post(sendOTPUrl, data, headers);
    return response.data;
  }

  const validateOTPApi = async (data) => {
    const response = await axios.post(validateOTPUrl, data, headers);
    return response.data;
  }

  const markAsUsedApi = async (data) => {
    const response = await axios.post(markAsUsedUrl, data, headers);
    return response.data;
  }

  return {
    forgotPasswordApi,
    changePasswordApi,
    sendOTPApi,
    validateOTPApi,
    markAsUsedApi,
  }
}
export default loginApi;
